import store from '../../../../store'
import mem_favorite from "./favorite/mem_favorite.vue";
import mem_sup_title from "./sup/mem_sup_title.vue";
import mem_block from "./body/mem_block.vue";
import mem_action from "./action/mem_action.vue";
import {mapGetters} from "vuex";

window.MEMORANDUM_INSIDE =  new Vue({
    store,
    el: '#memorandum_inside',
    name : "MEMORANDUM_INSIDE",

    async created() {

        EventBus.$on('reload_mem',event => {
            if(event.hasOwnProperty("mem_id")) {
                if(parseInt(event.mem_id) == parseInt(this.id)) {
                    this.$store.dispatch('memorandum_inside/LOAD_MEMORANDUM_INSIDE',this.id);
                }
            }
        });


        const el = document.getElementById('memorandum_inside');
        if (el && el.dataset.id) {
            this.id = el.dataset.id;
        }

        if(parseInt(this.id) > 0) {
            await this.$store.dispatch('memorandum_inside/LOAD_MEMORANDUM_INSIDE',this.id);
        }
    },

    data() {
        return {
            id: null,
        };
    },

    components : {
        mem_favorite,
        mem_sup_title,
        mem_block,
        mem_action
    },
    computed: {
        ...mapGetters({
            'access_denied': "memorandum_inside/access_denied"
        }),

    }
})
